/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from "react"
import PropTypes from "prop-types"

import "./layout.css"
import { GlobalStyles } from "../styles/global-style"
import MailingPopup from "./mailing-popup"
import { useRecoilValue } from "recoil"
import { currentAudioTrack, menuOpen, showingMailingPopup } from "../state/atoms"
import { FirebaseProvider } from "../services/index"
import Footer from "./layout/footer"
import Navbar from "./layout/navbar"
import MobileNavbar from "./layout/mobile-navbar"
import { useMedia } from "react-use"
import { AnimatePresence } from "framer-motion"
import Menu from "./layout/menu"
import CustomAudioPlayer from "./audio-player"

const Layout = ({ children, dark, animate }) => {
    const showMailingPopup = useRecoilValue(showingMailingPopup)
    const isMenuOpen = useRecoilValue(menuOpen)
    const currentAudio = useRecoilValue(currentAudioTrack)
    const isWide = useMedia("(min-width: 500px)")

    const html =
        typeof window !== "undefined" ? document.querySelector("html") : {}

    useEffect(() => {
        isMenuOpen
            ? (html.style.overflow = "hidden")
            : (html.style.overflow = "visible")
    }, [isMenuOpen])

    return (
        <FirebaseProvider>
            <GlobalStyles />
            {/* <Navbar /> */}
            {showMailingPopup && <MailingPopup />}
            {isWide ? (
                <Navbar dark={dark} animate={animate} />
            ) : (
                <>
                    <MobileNavbar dark={dark} animate={animate} />
                    <AnimatePresence>{isMenuOpen && <Menu />}</AnimatePresence>
                </>
            )}

            <main>{children}</main>
            <Footer />
            <AnimatePresence>
                {currentAudio && <CustomAudioPlayer audio={currentAudio} />}
            </AnimatePresence>
        </FirebaseProvider>
    )
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}

export default Layout
